import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = styled.button`
  border: none;
  border-radius: 0;
  background-color: ${({ theme }) => theme.colors.primary };
  color: ${({ theme }) => theme.colors.secondary };
  
  &:focus {
    outline: none;
  }
`;

Button.propTypes = {

};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.js